import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const CaretsDetailSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    const gridKey = "F356CC49-903C-4281-962A-130470836DC1";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
               
                <Scrolling mode="virtual" />
                <Column dataField="detailType" caption="Detail" />
                <Column dataField="customerId" caption="Customer" />
                <Column dataField="itemCode" caption="Item" />
                <Column dataField="lotCode" caption="Lot" />
                <Column dataField="subLotCode" caption="SubLot" />
                <Column dataField="quantityActual" format="#,##0.00" caption="Actual" />
                <Column dataField="quantityOrdered" format="#,##0.00" caption="Ordered" />
                <Column dataField="customerName" caption="Customer Name" visible={false} />
                <Column dataField="itemDescription1" caption="Item Description 1" visible={false} />
                <Column dataField="lotDescription1" caption="Lot Description 1" visible={false} />
                <Column dataField="subLotDescription1" caption="Sub Lot Description 1" visible={false} />
                <Column dataField="crateNumber" caption="Crate No." visible={false} />
                <Column dataField="inventoryUOMFlag" caption="Inventory UOM Flag" visible={false} />
                <Column dataField="itemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="itemClassCode" caption="Item Class Code" visible={false} />
                <Column dataField="itemSubclassCode" caption="Item Subclass Code" visible={false} />
                <Column dataField="itemType" caption="Item Type" visible={false} />
                <Column dataField="item_Code1" caption="Item Code 1" visible={false} />
                <Column dataField="item_Code2" caption="Item Code 2" visible={false} />
                <Column dataField="item_Code3" caption="Item Code 3" visible={false} />
                <Column dataField="item_Code4" caption="Item Code 4" visible={false} />
                <Column dataField="item_Code5" caption="Item Code 5" visible={false} />
                <Column dataField="item_Reference1" caption="Item Reference 1" visible={false} />
                <Column dataField="item_Reference2" caption="Item Reference 2" visible={false} />
                <Column dataField="item_Reference3" caption="Item Reference 3" visible={false} />
                <Column dataField="item_Reference4" caption="Item Reference 4" visible={false} />
                <Column dataField="item_Reference5" caption="Item Reference 5" visible={false} />
                <Column dataField="lotDescription2" caption="Lot Description 2" visible={false} />
                <Column dataField="lotClassCode" caption="Lot Class Code" visible={false} />
                <Column dataField="lotSubclassCode" caption="Lot Subclass Code" visible={false} />
                <Column dataField="lot_Code1" caption="% Germination" visible={false} />
                <Column dataField="lot_Code2" caption="% Foreign" visible={false} />
                <Column dataField="lot_Code3" caption="% Moisture" visible={false} />
                <Column dataField="lot_Code4" caption="% Attribute 4" visible={false} />
                <Column dataField="lot_Code5" caption="% Attribute 5" visible={false} />
                <Column dataField="lot_Reference1" caption="Lot Reference 1" visible={false} />
                <Column dataField="lot_Reference2" caption="Lot Reference 2" visible={false} />
                <Column dataField="lot_Reference3" caption="Lot Reference 3" visible={false} />
                <Column dataField="lot_Reference4" caption="Lot Reference 4" visible={false} />
                <Column dataField="lot_Reference5" caption="Lot Reference 5" visible={false} />
                <Column dataField="subLotDescription2" caption="Sub Lot Description 2" visible={false} />
                <Column dataField="sublot_Code1" caption="Sublot Code 1" visible={false} />
                <Column dataField="sublot_Code2" caption="Sublot Code 2" visible={false} />
                <Column dataField="sublot_Code3" caption="Sublot Code 3" visible={false} />
                <Column dataField="sublot_Code4" caption="Sublot Code 4" visible={false} />
                <Column dataField="sublot_Code5" caption="Sublot Code 5" visible={false} />
                <Column dataField="sublot_Reference1" caption="Sublot Reference 1" visible={false} />
                <Column dataField="sublot_Reference2" caption="Sublot Reference 2" visible={false} />
                <Column dataField="sublot_Reference3" caption="Sublot Reference 3" visible={false} />
                <Column dataField="sublot_Reference4" caption="Sublot Reference 4" visible={false} />
                <Column dataField="sublot_Reference5" caption="Sublot Reference 5" visible={false} />
                <Column dataField="transactionNumber" caption="Transaction#" visible={false} />
                <Column dataField="transactionDate" caption="Transaction Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="shipperBolNumber" caption="Shipper BOL Number" visible={false} />
                <Column dataField="createdBy" caption="Created By" visible={false} />
                <Column dataField="lastUpdatedBy" caption="Last Updated By" visible={false} />
                <Column dataField="creationDate" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="lastUpdatedDate" caption="Last Updated Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="referenceDateTime" caption="Reference Date Time" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="inventory" format="#,##0.00" caption="Inventory" visible={false}/>
                <Column dataField="record"   caption="Record#" visible={false} />
                <Column dataField="recordtype"   caption="Record type" visible={false} />
                <Column dataField="reference"   caption="Reference" visible={false} />
                <Column dataField="unitcode"   caption="UnitCode" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CaretsDetailSubTab);